import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  getAllSerialNumbers,
  getSerialNumberForUnit,
} from "@redotech/redo-fulfillment-group-common/scan-serial-numbers";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { StringListCell } from "../cells/string-list-cell";

const catalogEntry = fgColumnEntries["serial-number"];

export const SerialNumberColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const serialNumbers = getAllSerialNumbers(row.scanVerifiedItemized);
    if (serialNumbers.length === 0) {
      return null;
    }
    return (
      <StringListCell displayName="serial number" strings={serialNumbers} />
    );
  },
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    return (
      <RedoTableTextCell
        text={getSerialNumberForUnit(
          getExpandedItems(row),
          expansionIndex,
          row.scanVerifiedItemized,
        )}
      />
    );
  },
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: catalogEntry.sortDirection,
};
